<template>
  <card-block>
    <spinner-block v-model="dataProgress">
      <div v-if="data">
        <card-header>
          <template v-if="id">
            <router-link :to="{name: 'business_company.detail', params: {id: id}}">Компания</router-link><!-- -->:
            редактирование

          </template>
          <template v-else>
            <router-link :to="{name: 'business_company.list'}">Компании</router-link><!-- -->:
            создание
          </template>


        </card-header>
        <card-body>

          <gui-checkbox v-model="data.is_active" :error="dataError.is_active" label="Активный"/>
          <gui-input v-model="data.name" :error="dataError.name" label="Название"/>
          <gui-subscription-tariff-select v-model="data.subscription_tariff_id"
                                          :error="dataError.subscription_tariff_id"
                                          label="Тип скидки"/>

          <div class="mt-5">
            <button-save v-if="!data.id" @click="add()"/>
            <button-save v-else @click="save"/>
            <button-back/>
          </div>
        </card-body>
      </div>
    </spinner-block>
  </card-block>
</template>

<script>


import GuiSubscriptionTariffSelect from "@/components/Widget/GuiSubscriptionTariffSelect.vue";

export default {
  components: {GuiSubscriptionTariffSelect},
  data() {
    return {
      data: null,
      dataDefault: {
        name: '',
        is_active: '',
        subscription_tariff_id: '',
      },
      dataError: {
        name: '',
        is_active: '',
        subscription_tariff_id: '',
      },
      dataProgress: false,
    }
  },
  computed: {
    id() {
      return this.$route.params.id
    }
  },
  mounted() {
    this.init()
  },
  methods: {

    init() {
      if (this.id) {
        this.data = null
        this.loadData()
      } else {
        this.data = _.clone(this.dataDefault)
      }
    },
    loadData() {
      axiosGetValue('/api/admin/business-company/get', {id: this.id}, e => this.data = e, e => this.dataProgress = e)
    },

    save() {
      axiosFast({
        url: route('/api/admin/business-company/update'),
        data: {data: this.data, id: this.data.id},
        error: this.dataError,
        progress: e => this.dataProgress = e,
        result: () => {
          toastSuccess('Данные сохранены');
          this.$router.push({name: 'business_company.detail', params: {id: this.data.id}})
        },
      })
    },
    add() {
      axiosFast({
        url: route('/api/admin/business-company/create'),
        data: {data: this.data},
        error: this.dataError,
        progress: e => this.dataProgress = e,
        result: (data) => {
          toastSuccess('Данные добавлены');
          this.$router.push({name: 'business_company.detail', params: {id: data.id}})
        },
      })
    },
  },
}
</script>
